import * as React from 'react';
import styles from './styles.module.css'
import { DropDownListComponent } from '../../../components/DropDownList/DropDownListComponent';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import { BackHand, BatteryAlert, Lightbulb, Tungsten, WifiOff } from '@mui/icons-material';
import { useLanguageLocale } from '../../../hooks/language-locale-hooks';
import { ZoneDetail } from '../../../types/device';
import { getLuminaryBitStatusState, luminaryBitStatusEnum } from '../../enum/ENUM';
interface Props {
    lines: any[];
    selectedLine: any;
    setSelectedLine: (value: any) => void;
    selectedZone: any;
    setSelectedZone: (value: any) => void;
    zones: ZoneDetail[];
    luminaryCount: number;
    setSelectedStatuses?: (status: string[]) => void;
}

const LuminaryStatusFilterContainer: React.FunctionComponent<Props> = (props) => {

    const { t } = useLanguageLocale();
    const { lines, selectedLine, setSelectedLine, selectedZone, setSelectedZone } = props;

    const [selectedStatus, setSelectedStatus] = React.useState<string | undefined>(undefined);

    const handleLineChange = (value: any) => {
        setSelectedLine(lines.find((record: any) => record.id === value));
    }

    const handleZoneChange = (value: any) => {
        setSelectedZone(props.zones.find((record: any) => record.id === value));
    }
    const zoneItemList = props.zones.map(zone => ({
        id: zone.id.toString(), // ItemData expects id as string
        name: zone.name,
    }));

    const handleSelectedStatuses = (status: string | undefined) => {
        setSelectedStatus(status);
        if(status) {
            props.setSelectedStatuses?.([status]);
        }else {
            props.setSelectedStatuses?.([]);
        }
    }

    return <div className={styles.chipFilterContainer} data-testid="line-zone-chip-filter-container">
        <div>
            <div className={styles.lineZoneSelectionContainer}>
                <DropDownListComponent
                    marginTop={0}
                    value={`${t('DEVICE_DETAILS.LUMINARY_LINE')}: ${t('FILTER.ALL')}`}
                    list={lines}
                    handleSelection={(value: any) => { handleLineChange(value) }}
                    selected={selectedLine?.id}
                    defaultSelection={selectedLine?.id || ''} />
                {
                    selectedLine &&
                    <DropDownListComponent
                        marginTop={0}
                        value={`${t('DEVICE_DETAILS.LUMINARY_ZONE')}: ${t('FILTER.ALL')}`}
                        list={zoneItemList}
                        handleSelection={(value: any) => { handleZoneChange(Number(value)) }}
                        selected={selectedZone?.id}
                        defaultSelection={selectedZone?.id || ''}
                    />
                }
            </div>
        </div>
        <div className={styles.chipFilterContainerItemDevider}></div>
        <div>
            <div onClick={() => handleSelectedStatuses(undefined)} className={`${styles.statusChip} ${selectedStatus === undefined ? styles.active : ''}`} data-testid="line-zone-chip-filter-all">
                <span>{t('FILTER.ALL')} ({props.luminaryCount})</span>
            </div>
        </div>
        <div className={styles.chipFilterContainerItemDevider}></div>
        <div className={styles.statusFilterContainer}>
            {
                luminaryBitStatusEnum.map((status) => {
                    return <div onClick={() => {
                        handleSelectedStatuses(status.id);
                    }} style={{ display: 'inline-flex', alignContent: 'center', columnGap: 5 }} className={`${styles.statusChip} ${selectedStatus === status.id ? styles.active : ''}`} data-testid="line-zone-chip-filter-total-failed">
                        <img
                            src={getLuminaryBitStatusState(parseInt(status.id)).statusImage}
                            alt="logo"
                            style={{ display: 'flex', alignItems: 'right' }}
                            id="device-status-icon"
                            data-testid="device-status-icon"
                        />
                        <span>{t(getLuminaryBitStatusState(parseInt(status.id)).statusTitle)}</span>
                    </div>
                })
            }
        </div>
    </div>;
};

export default LuminaryStatusFilterContainer;
